<div class="st-form">
  <app-st-impersonation-floating-banner [impersonatedEmail]="this.impersonatedEmail"
                                        [username]="this.username"
                                        [roleName]="this.consultantRoleName"
                                        (exitViewAs)="this.onExitViewAs($event)"
  >

  </app-st-impersonation-floating-banner>
</div>
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="true" [elementTags]="this.elementTags" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br>
<div class="container-xxl">
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button [idVal]="'top-back-button-id'" [label]="'Back'" [primary]="true"
                     (click)="this.onBack()"></app-st-button>
      <app-st-button-pdf [idVal]="'top-export-pdf-button-id'" [label]="'Export As PDF'"
                         (click)="this.generateSearchablePdf()"></app-st-button-pdf>
    </div>
    <app-st-header-title [idVal]="'grant-general-info-id'" [inputVal]="'Grant Information'"></app-st-header-title>
    <div class="row pt-2">
      <div class="col">
        <span class="webtext-black"><strong>Recipient of Grant: </strong></span><span class="webtext-black"> {{this.recipientCompanyName}} </span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span class="webtext-black"><strong>Recipient EIN: </strong></span><span *ngIf="this.recipientEin" class="webtext-black"> {{this.recipientEin}} </span><span *ngIf="!this.recipientEin" class="webtext-black"> N/A </span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span class="webtext-black"><strong>Grant Amount: </strong>{{this.recipientCashAmtGrantFormatted}} USD</span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span class="webtext-black"><strong>Purpose: </strong> {{this.recipientDonorPurposeTxt}}</span>
      </div>
    </div>
    <br>
    <div class="row pt-2">
      <div class="col">
        <span class="webtext-black"><strong>Recipient Website: </strong></span>
        <!--
        <a *ngIf="this.recipientWebsiteUrl" target="_blank" href="{{this.recipientWebsiteUrl}}"> {{this.recipientWebsiteUrl}} </a>
        <span *ngIf="!this.recipientWebsiteUrl" class="webtext-black">N/A</span>-->
        <a *ngIf="this.recipientWebsiteUrl && (this.recipientWebsiteUrl.startsWith('http') || this.recipientWebsiteUrl.startsWith('www.') || this.recipientWebsiteUrl.includes('.org') || this.recipientWebsiteUrl.includes('.com') || this.recipientWebsiteUrl.includes('.net'))" target="_blank" href="{{this.recipientWebsiteUrl}}">{{this.recipientWebsiteUrl}}</a>
        <span *ngIf="!this.recipientWebsiteUrl || (!this.recipientWebsiteUrl.startsWith('http') && !this.recipientWebsiteUrl.startsWith('www.') && !this.recipientWebsiteUrl.includes('.org') && !this.recipientWebsiteUrl.includes('.com') && !this.recipientWebsiteUrl.includes('.net'))">No Website Available - We Recommend Calling</span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span class="webtext-black"><strong>Address: </strong></span><br>
        <div *ngIf="this.recipientStreetAddress">
          <span class="webtext-black"> {{this.recipientStreetAddress}} </span><br>
          <span class="webtext-black">{{this.recipientCity}}, {{this.recipientState}} {{this.recipientCountry}} {{this.formatZipCode(this.recipientZipCode)}}</span><br>
        </div>
        <div *ngIf="!this.recipientStreetAddress">
          N/A
        </div>
      </div>
    </div>
    <br>
    <!--
    <div class="row pt-2">
      <div class="col">
        <span class="webtext-black"><strong>Recipient Causes: </strong></span><span></span>
        <ul>
          <li *ngFor="let causeRow of this.recipientAllCauses">{{causeRow}}</li>
      </ul>
      </div>
    </div>-->
    <app-st-header-title [idVal]="'donor-info-id'"  [inputVal]="'Donor of Grant'"></app-st-header-title>
    <div class="row pt-2">
      <div class="col">
        <span class="webtext-black"><strong>Donor Name: </strong> {{this.donorOverviewRecord['companyName']}}</span>
        <br>
        <app-st-button [idVal]="'view-donor-details-button-id'" [label]="'View Donor Details and History'" [primary]="true"
                       (click)="this.onViewDonorDetails()"></app-st-button>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span class="webtext-black"><strong>Donor Website: </strong></span>
        <a *ngIf="this.donorOverviewRecord['websiteURL'] && (this.donorOverviewRecord['websiteURL'].startsWith('http') || this.donorOverviewRecord['websiteURL'].startsWith('www.') || this.donorOverviewRecord['websiteURL'].includes('.org') || this.donorOverviewRecord['websiteURL'].includes('.com') || this.donorOverviewRecord['websiteURL'].includes('.net'))" target="_blank" href="{{this.donorOverviewRecord['websiteURL']}}">{{this.donorOverviewRecord['websiteURL']}}</a>
        <span *ngIf="!this.donorOverviewRecord['websiteURL'] || (!this.donorOverviewRecord['websiteURL'].startsWith('http') && !this.donorOverviewRecord['websiteURL'].startsWith('www.') && !this.donorOverviewRecord['websiteURL'].includes('.org') && !this.donorOverviewRecord['websiteURL'].includes('.com') && !this.donorOverviewRecord['websiteURL'].includes('.net'))">No Website Available - We Recommend Calling</span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span class="webtext-black"><strong>Donor Phone Number: </strong></span><span> {{this.formatPhoneNumber(this.donorOverviewRecord['phoneNumber'])}} </span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <span class="webtext-black"><strong>Donor Address: </strong></span><br>
        <div *ngIf="this.donorOverviewRecord['taxFilingStreetAddress']">
          <span class="webtext-black"> {{this.donorOverviewRecord['taxFilingStreetAddress']}} </span><br>
          <span class="webtext-black">{{this.donorOverviewRecord['taxFilingCity']}}, {{this.donorOverviewRecord['taxFilingState']}} {{this.donorOverviewRecord['taxFilingCountry']}} {{this.formatZipCode(this.donorOverviewRecord['taxFilingZipCode'])}}</span><br>
        </div>
        <div *ngIf="!this.donorOverviewRecord['taxFilingStreetAddress']">
          <span class="webtext-black">N/A</span><br>
        </div>
      </div>
    </div>
    <br>
    <div>
      <app-st-header-title [idVal]="'donor-finances-id'"  [inputVal]="'Donor Financials for ' + this.donorDetailsRecord.taxYear + ''"></app-st-header-title>
      <div class="row pt-2">
        <div class="col">
          <span class="webtext-black"><strong>Tax Year: </strong></span><span>{{this.donorDetailsRecord['taxYear']}}</span>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col">
          <span class="webtext-black"><strong>Total Revenue: </strong></span><span>{{this.donorDetailsRecord['totalRevenueFormatted']}} USD</span>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col">
          <span class="webtext-black"><strong>Total Expenses: </strong></span><span>{{this.donorDetailsRecord['totalExpensesFormatted']}} USD</span>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col">
          <span class="webtext-black"><strong>Total Assets: </strong></span><span>{{this.donorDetailsRecord['totalAssetsFormatted']}} USD</span>
        </div>
      </div>
      <br>
      <app-st-header-title [idVal]="'donor-key-staff-id'"  [inputVal]="'Key Staff'"></app-st-header-title>
      <table class="table table-striped webtext-black">
        <thead>
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Title</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let keyEmployee of this.donorDetailsRecord['keyEmployeesList']">
          <td>{{keyEmployee['personName']}}</td>
          <td>{{keyEmployee['titleTxt']}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button [idVal]="'bottom-back-button-id'" [label]="'Back'" [primary]="true"
                     (click)="this.onBack()"></app-st-button>
      <app-st-button-pdf [idVal]="'bottom-export-pdf-button-id'" [label]="'Export As PDF'"
                     (click)="this.generateSearchablePdf()"></app-st-button-pdf>
    </div>
    <br>
  </div>
</div>
